import CopyDcaBot from "features/onboarding/methodSettings/dcaBot/CopyDcaBot";
import { useLocation } from "react-router-dom";
import { ONBOARDING_TRADING_METHOD_PATH } from "common/constants";
import OnboardingBotSetup from "features/onboarding/guided/OnboardingBotSetup";
import { useContext, useEffect } from "react";
import useQuery from "utils/hooks/useQuery";
import { OnboardingContext } from "@shared/features/onboarding/Onboarding.context";
import { OnboardingDetailedStep } from "@shared/features/onboarding/types";
import MethodWalkthrough from "features/onboarding/guided/MethodWalkthrough";
import { useTradingIntent } from "features/onboarding/guided/intent";
import { useExploreOnboardingStep } from "features/onboarding/common/ExploreOnboardingStep.context";
import { OnboardingStep as AnalyticsOnboardingStep } from "analytics/events";

const IntentNextStep = () => {
  const query = useQuery();
  // The key changes on every navigation: when one lands here again before
  // a render (two "account connected" handlers in a row), the redirect
  // runs again instead of leaving this blank step.
  const { pathname, key: locationKey } = useLocation();
  const settingUp = query.get("setup") === "1";
  const guided = query.get("guided") === "1";
  const { intent } = useTradingIntent();
  const { changeStep } = useContext(OnboardingContext)!;
  // Signals and DCA have their own routes: from the trading-method route
  // they redirect there, so nothing renders (or tracks a view) first.
  const redirecting =
    pathname === ONBOARDING_TRADING_METHOD_PATH &&
    !settingUp &&
    !(guided && intent !== "dca") &&
    (intent === "signals" || intent === "dca");
  useEffect(() => {
    if (pathname !== ONBOARDING_TRADING_METHOD_PATH) return;
    if (!intent) {
      changeStep(OnboardingDetailedStep.SELECT_EXCHANGE, {
        guided: "",
        setup: "",
        startMode: "",
      });
      return;
    }
    if (settingUp || (guided && intent !== "dca")) return;
    if (intent === "signals" || intent === "dca") {
      changeStep(
        intent === "signals"
          ? OnboardingDetailedStep.FOLLOW_SIGNALS_GROUP
          : OnboardingDetailedStep.COPY_DCA_BOT,
        { method: intent }
      );
    }
  }, [intent, pathname, locationKey, settingUp, guided]);
  useExploreOnboardingStep(
    intent && settingUp ? AnalyticsOnboardingStep.OVERVIEW : undefined
  );
  if (redirecting) return null;
  if (intent && settingUp) return <OnboardingBotSetup intent={intent} />;
  if (intent === "dca") return <CopyDcaBot />;
  return intent ? <MethodWalkthrough key={intent} intent={intent} /> : null;
};
export default IntentNextStep;
